import React from "react";
import { useDataManColumn } from "../../hooks/useDataManColumn";

export const DataManHierarchyHeaderColumnContent: React.FC = () => {
  const { column } = useDataManColumn();
  return (
    <div className="flex items-center justify-between px-6 py-3">
      <div>
        <h3 className="font-inter font-semibold text-content-muted text-section-label uppercase tracking-[0.04em]">
          {column?.title || ""}
        </h3>
      </div>
    </div>
  );
};
